export default __webpack_public_path__ + "static/media/landingBackground6Mobile.84cec70b.png";